import Chart from '../../../../../icons/chart-trending.svg';
import People from '../../../../../icons/people.svg';

export default function StatisticsData() {
    return {
      points: [
          {
              value: "46",
              icon : People,
              paragraph: "of business owners have a business protection plan in place."
          },
          {
            value: "44",
            icon : Chart,
            paragraph: "of growing businesses don't have an exit or continuation plan in place."
          },
        ],
        footer: {
          paragraph: "2019 Principal Financial Group Business Owner Survey, conducted by Harris Insights and Analytics"
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/StatisticsData.js